//加载格式化样式
require('com/css/global_flexible.scss');

import App from 'c/static_page/app.vue'
import coupon from 'c/static_page/coupon.vue'
import shopCity from 'c/static_page/shop_city.vue'
import Law from 'c/static_page/law.vue'
import platformProtocol from 'c/static_page/platform_protocol.vue'
import leasingContract from 'c/static_page/leasing_contract.vue'
import privacyPolicy from 'c/static_page/privacy_policy.vue'
import help from 'c/static_page/help.vue'
import commonProblem from 'c/static_page/common_problem.vue'
import helpDetail from 'c/static_page/help_detail.vue'
import licenseInformation from 'c/static_page/license_information.vue'

// 加载vue框架
var Vue = require('d/vue');
var vueRouter=require('vue-router')
Vue.use(vueRouter)

var router = new vueRouter()
router.map({
    'coupon':{ //优惠券说明
        component:coupon,
    },
    'shopCity':{ //商城说明
        component:shopCity,
    },
    'Law':{ //法律条款和隐私政策
        component:Law,
    },
    'platformProtocol':{ //响车车平台协议
        component:platformProtocol,
    },
    'leasingContract':{ //分时租赁合同
        component:leasingContract,
    },
    'privacyPolicy':{ //隐私政策
        component:privacyPolicy,
    },
    'help':{ //使用帮助3.0
        component:help,
    },
    'commonProblem':{ //常见问题
        component:commonProblem,
    },
    'helpDetail/:index':{ //使用帮助内容3.0
        component:helpDetail,

    },
    'licenseInformation':{ //证照信息
        component:licenseInformation,
    
    },

})
router.redirect({
    '/':'/coupon'
})
router.start(App,'#app')









// WEBPACK FOOTER //
// ./src/static_page.js